exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".kb-form__header-OdTT4t{display:flex;align-items:center;margin:0 0 20px 0;font-size:18px}", ""]);
